import axios from "../axiosInstance";

const memberAPI = {
  store: (payload) => axios.post("admin/member/store", payload),
  getList: (params) => axios.get("admin/member/list", { params }),
  update: (payload) => axios.post("admin/member/update", payload),
  delete: (payload) => axios.post("admin/member/delete", payload),

  getProfile: () => axios.get("admin/member/my-profile"),
  updateProfile: (payload) => axios.post("admin/member/updateProfile", payload),
  updatePassword: (payload) => axios.post("admin/member/update-password", payload),
  updateStatus: (payload) => axios.post("admin/member/updateStatus", payload),
};

export default memberAPI;
